import { useParams, type RouteObject } from 'react-router';
import { PartnerFormPage } from './PartnerFormPage';
import { CustomersPage } from './CustomersPage';
import { CustomerDetail } from './CustomerDetail';
import { SuppliersPage } from './SuppliersPage';
import { SupplierDetail } from './SupplierDetail';

function CustomerDetailPage() {
  const { id } = useParams();
  return <CustomerDetail key={id} id={id!} />;
}

function SupplierDetailPage() {
  const { id } = useParams();
  return <SupplierDetail key={id} id={id!} />;
}

/** 客户 / 供应商：path 相对 /v2 */
export const routes: RouteObject[] = [
  { path: 'customers/new', element: <PartnerFormPage kind="customer" mode="create" /> },
  { path: 'customers/:id/edit', element: <PartnerFormPage kind="customer" mode="edit" /> },
  { path: 'customers', element: <CustomersPage /> },
  { path: 'customers/:id', element: <CustomerDetailPage /> },
  { path: 'suppliers/new', element: <PartnerFormPage kind="supplier" mode="create" /> },
  { path: 'suppliers/:id/edit', element: <PartnerFormPage kind="supplier" mode="edit" /> },
  { path: 'suppliers', element: <SuppliersPage /> },
  { path: 'suppliers/:id', element: <SupplierDetailPage /> },
];
